import { IconChevronRight } from '@lib/icons'
import type React from 'react'
import type { FC } from 'react'

import type OnlyOneOf from '@/utils/types/OnlyOneOf'
import css from './TextWithAction.module.scss'

type Props = {
  actionText: string
  children?: React.ReactNode
} & OnlyOneOf<
  {
    actionFn: () => void
  },
  {
    actionUrl: string
  }
>

const TextWithAction: FC<Props> = ({
  children,
  actionText,
  actionFn,
  actionUrl,
}) => {
  const handleClick =
    actionFn ||
    (() => {
      window.open(actionUrl!, '_blank')
    })

  return (
    <p className={css.limit}>
      {children && <span className={css.children}>{children}</span>}
      <span className={css.link} onClick={handleClick}>
        {actionText} <IconChevronRight />
      </span>
    </p>
  )
}

export default TextWithAction
